import React, { FC } from 'react'
import { Button } from '@cargomart/ui'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, MutationDefinition } from '@reduxjs/toolkit/dist/query'
import { MutationTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks'
import IconRefresh from 'assets/refresh.svg?react'
import IconTrash from 'assets/trash.svg?react'
import classNames from 'classnames'
import { useIsMobile } from 'hooks/media'
import { TCustomer } from 'modules/customer/types'
import Widget from 'src/tailwind-components/extends/Widget/Widget'

import { TableColumn } from './TableColumn'
import { TableColumnHead } from './TableColumnHead'
import { TableColumnSkeleton } from './TableColumnSkeleton'

type TProps = {
  customers: TCustomer[] | undefined
  deleteCustomer: MutationTrigger<
    MutationDefinition<string, BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, never, string, 'api'>
  >
  handleOpenModalDelete: (e: React.SyntheticEvent, el: TCustomer) => void
  handleOpenModalDetail: (el: TCustomer) => void
  refetch: () => void
  className?: string
  isLoading?: boolean
  onAddCustomer?: () => void
}

export const Table: FC<TProps> = ({
  customers,
  isLoading,
  refetch,
  handleOpenModalDetail,
  handleOpenModalDelete,
  onAddCustomer
}) => {
  const isMobile = useIsMobile()

  const skeleton = [...new Array(10)].map((_, i) => <TableColumnSkeleton key={i} isMobile={isMobile} />)

  const empty = <>У вас пока не добавлено ни одного контрагента</>

  return (
    <Widget className="bg-surface">
      <div className="relative" data-test-id="customer--table">
        <div className={classNames('flex items-center justify-between p-4', 'max-md:flex-col max-md:pb-0')}>
          <div
            className={classNames(
              'flex w-full items-center justify-between',
              'max-md:flex max-md:w-full max-md:justify-between'
            )}
          >
            <h2 className="text-black text-headline-md">Контрагенты</h2>
            <div className="flex items-center gap-4">
              <IconRefresh className="cursor-pointer" onClick={refetch} size="sm" />
              <Button className="max-md:hidden" color="primary" onClick={onAddCustomer} variant="solid">
                Добавить
              </Button>
            </div>
          </div>
          <div className="max-md:w-full">
            <Button
              className={classNames('mx-0 my-2 hidden w-full', 'max-md:flex')}
              color="primary"
              onClick={onAddCustomer}
              size="lg"
              variant="solid"
            >
              Добавить
            </Button>
          </div>
        </div>
        <div data-name="table">
          <TableColumnHead isMobile={isMobile} />
          {/* eslint-disable-next-line */}
          {!isLoading ? (
            customers?.length ? (
              customers.map((el) => (
                <TableColumn
                  key={el.id}
                  id={el.id}
                  inn={el.inn}
                  isMobile={isMobile}
                  kpp={el.kpp}
                  name={el.name}
                  onClick={() => handleOpenModalDetail(el)}
                  onDeleteButtonClick={(e: React.SyntheticEvent) => handleOpenModalDelete(e, el)}
                  deleteButton={
                    el.access.delete ? (
                      <IconTrash onClick={(e: React.SyntheticEvent) => handleOpenModalDelete(e, el)} size="xs" />
                    ) : (
                      ''
                    )
                  }
                />
              ))
            ) : (
              <div
                className={classNames(
                  'justify-center px-4 py-14 text-center text-[#6e7076]',
                  'max-md:items-center max-md:shadow-[inset_0_1px_0_rgba(0,0,0,0.12)]'
                )}
              >
                {empty}
              </div>
            )
          ) : (
            skeleton
          )}
        </div>
      </div>
    </Widget>
  )
}
